<template lang="pug">
v-container#user-tables(fluid, tag="div")
  h3 User List
  v-btn.mb-3(color="#03B3EB", @click="toggleAdd") Add New User
  v-dialog(data-app, v-model="add", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Add User
      v-card-text
        v-form(ref="form", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            v-model="userName",
            :rules="usernameRules",
            label="Username",
            required
          )
          v-text-field.mb-2(
            type="password"
            v-model="userPassword",
            :rules="passwordRules",
            label="Password",
            required
          )
          v-text-field.mb-2(
            v-model="userEmail",
            :rules="emailRules",
            label="E-mail",
            required
          )
          v-text-field.mb-2(
            v-model="userCompany",
            label="Company"
          )
          v-text-field.mb-2(
            v-model="userFullname",
            :rules="[(v) => !!v || 'Full name is required']",
            label="Full name",
            required
          )
          v-textarea.mb-2(
            v-model="userExtra",
            label="Extra Data"
          )
      v-card-actions
        v-btn(color="#FD0101", text, @click="closeAdd") Cancel
        v-btn(color="#03B3EB", text, @click="submit") Submit
        v-btn(color="#2DC64F", text, @click="reset") Reset
  v-dialog(data-app, v-model="dialog", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Edit User
      v-card-text
        v-form(ref="edit", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            type="password"
            v-model="editedItem.password_hash",
            :rules="passwordRules",
            label="Password",
            required
          )
          v-text-field.mb-2(
            v-model="editedItem.email",
            :rules="emailRules",
            label="E-mail",
            required
          )
          v-text-field.mb-2(
            v-model="editedItem.company",
            label="Company"
          )
          v-text-field.mb-2(
            v-model="editedItem.full_name",
            :rules="[(v) => !!v || 'Full name is required']",
            label="Full name",
            required
          )
          v-textarea.mb-2(
            v-model="editedItem.extra_data",
            label="Extra Data"
          )
          v-select.mb-2(
            data-app,
            v-model="editedItem.status",
            :items="status_list",
            item-text="status_name",
            item-value="status_id",
            :rules="[(v) => !!v || 'Status is required']",
            label="Status",
            required
          )
      v-card-actions
        v-btn(color="#FD0101", text, @click="close") Cancel
        v-btn(color="#03B3EB", text, @click="save") Save
  v-card
    v-card-title
      v-text-field.my-2(
        v-model="search",
        append-icon="mdi-magnify",
        label="Search",
        single-line,
        hide-details
      )
    v-data-table(
      :headers="user_headers",
      :items="user_list",
      :search="search"
    )
      template(v-slot:item.status="{ item }")
        td {{ parseInt(item.status) == 2 ? 'NOT VERIFIED' : parseInt(item.status) == 1 ? 'ACTIVE' : 'SUSPENDED' }}
      template(v-slot:item.created_at="{ item }")
        td {{ $moment(parseInt(item.created_at*1000)).format("DD MMM YYYY hh:mm a") }}
      template(v-slot:item.updated_at="{ item }")
        td {{ $moment(parseInt(item.updated_at*1000)).format("DD MMM YYYY hh:mm a") }}
      template(v-slot:item.actions="{ item }")
        td.d-flex.flex-row
          v-icon.mr-2(small, color="#03B3EB", @click="editUser(item)") mdi-pencil
          v-icon(small, color="#2DC64F", @click="deleteUser(item)") mdi-delete
  v-dialog(data-app, persistent, v-model="dialogDelete", max-width="600px")
    v-card
      v-card-title.headline Are you sure you want to delete <br> {{ editedItem.name }} user?
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closeDelete") Cancel
        v-btn(color="blue darken-1", text, @click="deleteUserConfirm") OK
        v-spacer
</template>

<script>
export default {
  name: "User",
  data() {
    return {
      search: "",
      add: false,
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {},
      user_list: [],
      status_list: [
        {
          status_id: "0",
          status_name: "Suspended",
        },
        {
          status_id: "1",
          status_name: "Active",
        },
      ],
      user_headers: [
        { text: "Actions", value: "actions" },
        { text: "#", value: "id", cellClass: "font-weight-bold" },
        { text: "Username", value: "username" },
        { text: "Key", value: "auth_key" },
        { text: "Verify Token", value: "verify_token" },
        { text: "E-mail", value: "email" },
        { text: "Type", value: "type" },
        { text: "Company", value: "company" },
        { text: "Full Name", value: "full_name" },
        { text: "Role", value: "role_id" },
        { text: "Extra", value: "extra_data" },
        { text: "Login IP", value: "last_login_ip" },
        { text: "Login Time", value: "last_login_at" },
        { text: "Active Time", value: "last_active_at" },
        { text: "Login Status", value: "login_status" },
        { text: "Login Attempt", value: "login_attempt" },
        { text: "C.By", value: "created_by" },
        { text: "C.Dt", value: "created_at" },
        { text: "M.By", value: "updated_by" },
        { text: "M.Dt", value: "updated_at" },
        { text: "Status", value: "status" },
      ],
      usernameRules: [
        v => !!v || 'Username is required',
        v => (v && v.length <= 20) || 'Username must be less than 20 characters',
        v => (v && v.length >= 6) || 'Username must be more than 5 characters',
        v => (v && /^[a-z\d._]*$/i.test(v)) || 'Username must be alphanumeric only',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      userName: null,
      userPassword: "",
      userEmail: "",
      userCompany: "",
      userFullname: "",
      userRole: "user",
      userExtra: "",
      valid: true,
      loading: false,
    };
  },
  mounted() {
    $("#addUser").hide();
    this.getUserList();
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;

      const url = "https://saas-api.xendity.com/v1/auth/register";

      const json = {
        parent: this.$store.getters.userId,
        username: this.userName,
        password: this.userPassword,
        email: this.userEmail,
        type: this.$store.getters.userType,
        company: this.userCompany,
        full_name: this.userFullname,
        role_id: this.userRole,
        extra_data: this.userExtra,
        created_by: this.$store.getters.userId,
        created_at: new Date().getTime(),
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Create user error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Create user successful!", "Success", "success");
                this.closeAdd();
                this.getUserList();
              }
            }
          } catch (error) {
            this.$swal("Create user error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Create user error", response.body.data.message, "error");
        });
    },
    save() {
      if (!this.$refs.edit.validate()) return;

      const url = "https://saas-api.xendity.com/v1/user/update";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        user_id: this.editedItem.id,
        password: this.editedItem.password_hash,
        email: this.editedItem.email,
        company: this.editedItem.company,
        full_name: this.editedItem.full_name,
        extra_data: this.editedItem.extra_data,
        status: this.editedItem.status
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Update user error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Update user successful!", "Success", "success");
                this.close();
                this.getUserList();
              }
            }
          } catch (error) {
            this.$swal("Create user error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Update user error", response.body.data.message, "error");
        });
    },
    editUser(item) {
      this.editedIndex = this.user_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    reset() {
      this.$refs.form.reset();
    },
    toggleAdd() {
      this.add = true;
    },
    deleteUser(item) {
      this.editedIndex = this.user_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteUserConfirm() {
      const url = "https://saas-api.xendity.com/v1/auth/delete";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        user_id: this.editedItem.id,
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Delete user error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Delete user successful!", "Success", "success");
                this.closeDelete();
                this.getUserList();
              }
            }
          } catch (error) {
            this.$swal("Delete user error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Delete user error", response.body.data.message, "error");
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    closeAdd() {
      this.add = false;
      this.reset();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    getUserList() {
      const url = "https://saas-api.xendity.com/v1/auth/list-sub";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then((response) => {
          // Success
          try {
            if (response) {
              if (response.body.success == false)
                this.$swal(
                  "Get user user list failed",
                  response.body.data.message,
                  "error"
                );
              else this.user_list = response.body.data.user_list;
            }
          } catch (error) {
            this.$swal(
              "Get user user list failed",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Get user user list failed",
            response.body.data.message,
            "error"
          );
        });
    }
  },
};
</script>